import React, { useState, useEffect } from 'react';
import 'src/app/popup.scss';
import styles from 'src/app/pages/RealLifeSupport/tabs/TroubleTicketTab/TroubleTicket.module.scss';
import './style.scss';
import fileDownload from 'js-file-download';

import { useDispatch, useSelector } from 'react-redux';
import { reduxRootTypes } from 'src/types';
import { contentsActions, eventActions } from 'src/app/redux/actions';
import moment from 'moment';
import { eventService, settingService } from 'src/app/services';

import { deleteConfirmTitles, Item, SettingPropsType } from './setting.config';

import useSearch from 'src/app/hooks/useSearch';
import CustomTable from 'src/app/components/CustomTable/CustomTable';
import { SettingDataType, SettingResultType } from 'src/types/services/setting-service.type';
import SettingForm from 'src/app/components/Forms/SettingForm/settingForm';
import { checkPermissionList } from 'src/app/helpers/permissions.helper';
import { PermissionEnum } from 'src/enums/permission.enum';
import { ExportOutlined, ImportOutlined } from '@ant-design/icons';

import { useTranslation } from 'react-i18next';
import { statusHelper } from 'src/app/helpers';
import { useUsers } from 'src/app/context/UserContext';

import Input from 'antd/es/input';
import Form from 'antd/es/form';
import Popover from 'antd/es/popover';
import Typography from 'antd/es/typography';
import Popconfirm from 'antd/es/popconfirm';
import Tooltip from 'antd/es/tooltip';
import Button from 'antd/es/button/button';
import message from 'antd/es/message';

const { Search } = Input;

const SettingTab: React.FC<SettingPropsType> = () => {
  const { t } = useTranslation();

  const defaultSettingData = {
    id: '',
    name: '',
    createdById: '',
    description: '',
    roadToCurrentState: '',
    creationDate: moment(new Date()),
    geoDataSet: '',
    geoSituation: '',
    keyPersonSet: '',
    agentData: '',
    log: '',
    comment: '',
  };
  const { settingList } = useSelector((state: reduxRootTypes.RootStateType) => state.settingState);

  const [modalInEditMode, setModalInEditMode] = useState<boolean>(false);
  const [modalInViewMode, setModalInViewMode] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [isViewMode, setIsViewMode] = useState<boolean>(false);
  const [choosenRow, setChoosenRow] = useState<any>();

  const { eventList, eventName } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);

  const [addSettingModal, setAddSettingModal] = useState<boolean>(false);
  const { searchValue, onSearch } = useSearch();

  const [dataCount, setDataCount] = useState<number>(0);

  const { preferredLanguage } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);

  const { usersList } = useUsers();

  const [form] = Form.useForm();
  const [dataForSetting, setDataForSetting] = useState<Item[]>([]);
  const [settingAllData, setSettingAllData] = useState<SettingResultType[]>([]);
  const [settingDataInForm, setSettingDataInForm] = useState<SettingDataType>(defaultSettingData);
  const [id, setId] = useState<number>();
  const [currentSettingId, setCurrentSettingId] = useState<string>('');

  const dispatch = useDispatch();
  const lastVisitedKey = settingDataInForm.id || '';

  useEffect(() => {
    const clearData: Item[] = [];
    settingAllData.forEach((item) => {
      const dateFormat = 'YYYY-MM-DD-HH:mm';
      clearData.push({
        id: item.id,
        name: item.name,
        createdById: item.createdById,
        // log: item.log,
        // comment: item.comment,
        description: item.description,
        creationDate: moment(item.creationDate).format(dateFormat),
        roadToCurrentState: item.roadToCurrentState,
        keyPersonSet: item.keyPersonSet,
        geoDataSet: item.geoDataSet,
        geoSituation: item.geoSituation,
        agentData: item.agentData,
      });
    });
    setDataForSetting(clearData);
  }, [settingAllData]);

  const getSettingData = async () => {
    try {
      const SettingListData = await settingService.lookupSetting({
        value: searchValue.length > 0 ? searchValue : undefined,
        blockSpinner: true,
      });

      let max = 0;
      SettingListData.data.rows.forEach((each) => {
        const value = Number(each.id.split('-')[1]);
        if (value > max) {
          max = value;
        }
      });
      setId(max + 1);
      setSettingAllData(SettingListData.data.rows);
      setDataCount(SettingListData.data.count);
      dispatch(contentsActions.settingList(SettingListData.data.rows));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setSettingAllData(settingList);
  }, [settingList]);

  useEffect(() => {
    getSettingData();
  }, [usersList, id, searchValue]);

  const onClickAddSetting = () => {
    if (modalInEditMode || modalInViewMode) {
      setSettingDataInForm(defaultSettingData);
    }
    setAddSettingModal(true);
    setModalInEditMode(false);
    setModalInViewMode(false);
  };

  const onClickShow = (record: Partial<Item> & { id: React.Key }) => {
    setAddSettingModal(true);
  };

  const edit = (record: Partial<Item> & { id: React.Key }) => {
    const item = settingAllData.find((o) => o.id === record.id);
    if (item) {
      onClickShow(record);
      setModalInEditMode(true);
      setChoosenRow(record);
      setIsEditMode(true);
      setIsViewMode(false);
      setModalInViewMode(false);
      setSettingDataInForm({
        ...item,
        creationDate: moment(item.creationDate),
      });
    }
  };
  const view = (record: Partial<Item> & { id: React.Key }) => {
    const item = settingAllData.find((o) => o.id === record.id);
    if (item) {
      onClickShow(record);
      setChoosenRow(record);
      setIsEditMode(false);
      setModalInEditMode(false);
      setModalInViewMode(true);
      setIsViewMode(true);
      setSettingDataInForm({
        ...item,
        creationDate: moment(item.creationDate),
      });
    }
  };

  const deleteSetting = async (deletedItem: Item) => {
    try {
      getSettingData();
      const sId = deletedItem.id;

      await settingService.SettingDelete({ id: deletedItem.id.toString() });

      const currentEvents = eventList.filter((e) => e.settingId === sId);

      if (deletedItem.id === settingDataInForm.id) {
        setSettingDataInForm(defaultSettingData);
      }
      setSettingAllData(settingAllData.filter((item) => item.id !== deletedItem.id));
      dispatch(contentsActions.settingDelete(deletedItem.id));

      currentEvents.forEach(async (currentEvent) => {
        if (!currentEvent) return;

        const eventUpdateData = await eventService.eventEdit({
          ...currentEvent,
          settingId: undefined,
        });
        dispatch(eventActions.eventEdited(eventUpdateData.data));
      });

      statusHelper.displaySuccessStatusMessage(t('success.deleted'));
    } catch (error) {
      console.log(error);
    }
  };

  const exportSetting = async (record: Item) => {
    const hide = message.loading({
      content: 'Exporting...',
      duration: 0,
    });
    try {
      const response = await settingService.exportSetting(record.id);

      if (response.status == 201) {
        fileDownload(response.data, `Setting-${record.name}-${record.id}.zip`);
        statusHelper.displaySuccessStatusMessage(t('success.exported'));
      } else {
        statusHelper.displayErrorMessage('errors.badRequest');
      }

      hide();
    } catch (error) {
      console.log(error);
      hide();
    }
  };

  const importSetting = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const hide = message.loading('Importing...', 0);
    const file = event.target.files?.[0];

    if (file) {
      try {
        const response = await settingService.importSetting(eventName, currentSettingId, file);

        hide();

        if (response.status === 201) {
          message.success('Import successful');
        } else {
          message.error('Import failed.');
        }
      } catch (error) {
        console.error('Import error:', error);
        hide();
        message.error('Import failed.');
      }
    } else {
      message.error('Please select a valid zip file.');
      hide();
    }

    event.target.value = '';
  };

  const columns = [
    {
      title: t('administration.scenarioSettings.name'),
      dataIndex: 'name',
      width: '6.5%',
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
    },
    {
      title: t('general.description'),
      dataIndex: 'description',
      width: '7%',
      sorter: (a: any, b: any) => a.description.localeCompare(b.description),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.description} trigger="hover">
            <div className={styles.tableTitleStyle}>{record.description}</div>
          </Popover>
        );
      },
    },
    {
      title: t('administration.scenarioSettings.roadToCurrentState'),
      dataIndex: 'roadToCurrentState',
      width: '7%',
      sorter: (a: any, b: any) => a.roadToCurrentState.localeCompare(b.roadToCurrentState),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.roadToCurrentState} overlayStyle={{ maxWidth: '500px', wordBreak: 'break-word' }}>
            <div className={styles.tableTitleStyle}>{record.roadToCurrentState}</div>
          </Popover>
        );
      },
    },
    {
      title: t('administration.scenarioSettings.keyPersonSet'),
      dataIndex: 'keyPersonSet',
      width: '7%',
      sorter: (a: any, b: any) => a.keyPersonSet.localeCompare(b.keyPersonSet),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.keyPersonSet} overlayStyle={{ maxWidth: '500px', wordBreak: 'break-word' }}>
            <div className={styles.tableTitleStyle}>{record.keyPersonSet}</div>
          </Popover>
        );
      },
    },
    {
      title: t('administration.scenarioSettings.geoDataSet'),
      dataIndex: 'geoDataSet',
      width: '7%',
      sorter: (a: any, b: any) => a.geoDataSet.localeCompare(b.geoDataSet),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.geoDataSet} overlayStyle={{ maxWidth: '500px', wordBreak: 'break-word' }}>
            <div className={styles.tableTitleStyle}>{record.geoDataSet}</div>
          </Popover>
        );
      },
    },
    {
      title: t('administration.scenarioSettings.geoSituation'),
      dataIndex: 'geoSituation',
      width: '7%',
      sorter: (a: any, b: any) => a.geoSituation.localeCompare(b.geoSituation),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.geoSituation} overlayStyle={{ maxWidth: '500px', wordBreak: 'break-word' }}>
            <div className={styles.tableTitleStyle}>{record.geoSituation}</div>
          </Popover>
        );
      },
    },
    {
      title: t('administration.scenarioSettings.agentData'),
      dataIndex: 'agentData',
      width: '7%',
      sorter: (a: any, b: any) => a.agentData.localeCompare(b.agentData),
      render: (value: any, record: any) => {
        return (
          <Popover content={record.agentData} overlayStyle={{ maxWidth: '500px', wordBreak: 'break-word' }}>
            <div className={styles.tableTitleStyle}>{record.agentData}</div>
          </Popover>
        );
      },
    },
    {
      title: t('general.creationDate'),
      dataIndex: 'creationDate',
      width: '7%',
      sorter: (a: any, b: any) => {
        const firstDate = moment(a.creationDate, 'YYYY-MM-DD-HH:mm').unix();
        const secondDate = moment(b.creationDate, 'YYYY-MM-DD-HH:mm').unix();
        return firstDate - secondDate;
      },
      onFilter: (value: any, record: any) => {
        let res: boolean = false;
        const dateValue = moment(record.creationDate, 'YYYY-MM-DD-HH:mm').unix();
        switch (value) {
          case 'Last Day':
            res = dateValue >= moment().subtract(1, 'day').unix();
            break;
          case 'Last Week':
            res = dateValue >= moment().subtract(1, 'week').unix();
            break;
          case 'Last Month':
            res = dateValue >= moment().subtract(1, 'month').unix();
            break;
          case 'Last Year':
            res = dateValue >= moment().subtract(1, 'year').unix();
            break;
        }
        return res;
      },
      // filters: filterDateOptions,
    },

    {
      title: t('general.operation.operation'),
      dataIndex: 'operation',
      width: '6%',
      fixed: 'right' as const,
      render: (_: any, record: Item) => {
        return (
          <div style={{ width: '65px', display: 'flex' }}>
            <Popover content={<div>{t('general.operation.view')}</div>} trigger="hover">
              <Typography.Link onClick={() => view(record)}>
                <img className="view-icon" src="/assets/moreIcon.png" alt="view" />
              </Typography.Link>
            </Popover>

            <Popover content={<div>{t('general.operation.edit')}</div>} trigger="hover">
              <Typography.Link
                onClick={() => edit(record)}
                disabled={checkPermissionList(PermissionEnum.SettingUpdate)}
              >
                <img className="edit-icon" src="/assets/editIcon.png" alt="edit" />
              </Typography.Link>
            </Popover>

            <Popover content={<div>{t('general.operation.export')}</div>} trigger="hover">
              <ExportOutlined
                style={{
                  fontSize: 20,
                  marginLeft: 10,
                  marginTop: 3,
                }}
                onClick={() => {
                  exportSetting(record);
                }}
              />
            </Popover>

            <Popover content={<div>{t('general.operation.import')}</div>} trigger="hover">
              <label htmlFor="file-upload">
                <ImportOutlined
                  style={{
                    fontSize: 20,
                    marginLeft: 10,
                    marginTop: 3,
                  }}
                  onClick={() => setCurrentSettingId(record.id)}
                />
              </label>
              <input id="file-upload" type="file" accept=".zip" style={{ display: 'none' }} onChange={importSetting} />
            </Popover>

            <Popover content={<div>{t('general.operation.delete')}</div>} trigger="hover">
              <Popconfirm
                placement="bottom"
                title={deleteConfirmTitles().title}
                okText={deleteConfirmTitles().okText}
                cancelText={deleteConfirmTitles().cancelText}
                icon=""
                onCancel={() => deleteSetting(record)}
                disabled={checkPermissionList(PermissionEnum.SettingDelete)}
              >
                <img
                  className="delete-icon"
                  src="/assets/deleteIcon.png"
                  alt="delete"
                  aria-disabled={checkPermissionList(PermissionEnum.SettingDelete)}
                />
              </Popconfirm>
            </Popover>
          </div>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        inputType: col.dataIndex === 'type' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
      }),
      title: (
        <Tooltip title={col.title}>
          <span className={styles.tableTitleStyle}>{col.title}</span>
        </Tooltip>
      ),
    };
  });

  return (
    <>
      <div className="database-main-container">
        <div className="database-container">
          <div className="database-add-button-container">
            <Button
              className="database-add-button"
              onClick={onClickAddSetting}
              disabled={checkPermissionList(PermissionEnum.SettingCreate)}
            >
              <div className="database-add-button-inner-container">
                <p className="database-add-button-text">{t('administration.scenarioSettings.addSetting')}</p>
              </div>
            </Button>
            <Search
              placeholder={t('general.search') || ''}
              allowClear
              onSearch={onSearch}
              onChange={onSearch}
              className="database-search-box"
            />
          </div>
          <Form form={form} component={false}>
            <CustomTable
              id="SettingTable"
              dataSource={dataForSetting}
              columns={mergedColumns}
              rowClassName={(record) => (record.id === lastVisitedKey.toString() ? 'last-visited-row' : '')}
            />
          </Form>
        </div>
      </div>

      {addSettingModal && (
        <SettingForm
          setEditModal={modalInEditMode}
          setViewModal={modalInViewMode}
          settingForm={settingDataInForm}
          onClickOpen
          setOnClickOpen={setAddSettingModal}
        />
      )}
    </>
  );
};

export default SettingTab;
